import React from "react";

const SecondaryLoader = ({ message = "Loading, please wait..." }) => {
  return (
    <div className="flex items-center justify-center min-h-[100px]">
      <div className="flex items-center gap-3">
        {/* Loading Spinner */}
        <div className="w-6 h-6 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>

        {/* Loading Text */}
        <p className="text-lg font-medium text-gray-600">
          {message}
        </p>
      </div>
    </div>
  );
};

export default SecondaryLoader;
